// Helpers for comparing a route stop's estimated arrival (est_arrival "HH:MM")
// against the actual recorded arrival timestamp (arrived_at, ISO/UTC).

export const parseHHMM = (t) => {
  if (!t || typeof t !== 'string') return null;
  const m = t.match(/^(\d{1,2}):(\d{2})/);
  if (!m) return null;
  return parseInt(m[1], 10) * 60 + parseInt(m[2], 10);
};

// Returns { actualTime: "HH:MM", diffMin: number|null, tone, arrivedBy } or null.
// tone: 'early' (<= ETA), 'warn' (1-15m late), 'late' (>15m late), 'neutral' (no ETA).
export const getStopArrival = (stop) => {
  if (!stop || !stop.arrived_at) return null;
  const d = new Date(stop.arrived_at);
  if (isNaN(d.getTime())) return null;

  const hh = String(d.getHours()).padStart(2, '0');
  const mm = String(d.getMinutes()).padStart(2, '0');
  const actualTime = `${hh}:${mm}`;
  const actualMin = d.getHours() * 60 + d.getMinutes();

  const etaMin = parseHHMM(stop.est_arrival);
  let diffMin = null;
  let tone = 'neutral';
  if (etaMin != null) {
    diffMin = actualMin - etaMin; // positive => late
    if (diffMin <= 0) tone = 'early';
    else if (diffMin <= 15) tone = 'warn';
    else tone = 'late';
  }
  return { actualTime, diffMin, tone, arrivedBy: stop.arrived_by_name || null };
};

export const diffLabel = (diffMin) => {
  if (diffMin == null) return '';
  if (diffMin === 0) return 'on time';
  const sign = diffMin > 0 ? '+' : '\u2212';
  return `${sign}${Math.abs(diffMin)}m`;
};
